var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReleaseSeats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3879 15.1836L17.5866 18.3326",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08956 15.1836L2.89087 18.3326",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81321 3.35285L3.89632 9.01952C3.60113 10.8439 5.00973 12.4987 6.8578 12.4987L13.1423 12.4987C14.9904 12.4987 16.3989 10.8439 16.1038 9.01952L15.1869 3.35285C14.9518 1.89986 13.6973 0.832031 12.2254 0.832031H10H7.7747C6.30281 0.832031 5.04831 1.89986 4.81321 3.35285Z",
    fill: "url(#paint0_linear_3806_9625)",
    stroke: "url(#paint1_linear_3806_9625)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09347 13.7791C0.552654 12.0878 1.81458 10.3594 3.59031 10.3594H16.5271C18.3028 10.3594 19.5648 12.0878 19.0239 13.7791C18.6767 14.8651 17.6673 15.6021 16.5271 15.6021H3.59031C2.45014 15.6021 1.44073 14.8651 1.09347 13.7791Z",
    fill: "url(#paint2_linear_3806_9625)",
    stroke: "url(#paint3_linear_3806_9625)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3806_9625",
    x1: 10,
    y1: 0.611871,
    x2: 9.77248,
    y2: 12.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3806_9625",
    x1: 10,
    y1: 0.832031,
    x2: 10,
    y2: 12.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3806_9625",
    x1: 10.0587,
    y1: 10.2604,
    x2: 10.0282,
    y2: 15.7571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3806_9625",
    x1: 10.0587,
    y1: 10.3594,
    x2: 10.0587,
    y2: 15.6021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseSeats);
export default __webpack_public_path__ + "static/media/Release Seats.c08dc45b3e170415db03962858d6568b.svg";
export { ForwardRef as ReactComponent };